const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17092_23774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66634 3.99998V1.99998C4.66634 1.82317 4.73658 1.6536 4.8616 1.52858C4.98663 1.40355 5.1562 1.33331 5.33301 1.33331H10.6663C10.8432 1.33331 11.0127 1.40355 11.1377 1.52858C11.2628 1.6536 11.333 1.82317 11.333 1.99998V3.99998H14.6663V5.33331H13.333V14C13.333 14.1768 13.2628 14.3464 13.1377 14.4714C13.0127 14.5964 12.8432 14.6666 12.6663 14.6666H3.33301C3.1562 14.6666 2.98663 14.5964 2.8616 14.4714C2.73658 14.3464 2.66634 14.1768 2.66634 14V5.33331H1.33301V3.99998H4.66634ZM8.94234 9.33331L10.121 8.15465L9.17834 7.21198L7.99967 8.39065L6.82101 7.21198L5.87834 8.15465L7.05701 9.33331L5.87834 10.512L6.82101 11.4546L7.99967 10.276L9.17834 11.4546L10.121 10.512L8.94234 9.33331ZM5.99967 2.66665V3.99998H9.99967V2.66665H5.99967Z",
    fill: "#B42318",
    style: {
      fill: "#B42318",
      fill: "color(display-p3 0.7059 0.1373 0.0941)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17092_23774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteQuestion);
export default __webpack_public_path__ + "static/media/delete-question.2929e031dc8fb25a01151ce1a91e78ef.svg";
export { ForwardRef as ReactComponent };